import {EuropastryBaseHandler} from "@app/core/shared/infrastructure/base.handler/europastry-base.handler";
import {ApiUrls} from "@app/core/shared/infrastructure/api-urls";
import {Injectable} from "@angular/core";
import {DeliveryPointLocal} from "@app/core/delivery-point/domain/delivery-point.local";
import {Observable} from "rxjs";
import {CredentialsStorage} from "@app/core/credentials/domain/credentials-storage";
import {HandlerBuilder, HttpMethod} from "@app/core/shared/infrastructure/base.handler/base-handle.parameters";
import {map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class FindPaymentMethodsWs {
    private static readonly RESULTS_KEY = 'results';

    constructor(
        private readonly handler: EuropastryBaseHandler,
        private readonly apiUrls: ApiUrls,
        private readonly deliveryPointLocal: DeliveryPointLocal,
        private readonly credentialsStorage: CredentialsStorage,
    ) {}

    execute(): Observable<Record<string, any>> {
        const deliveryPointCode = this.deliveryPointLocal.getDeliveryPointCode();
        const parameters = new HandlerBuilder()
            .method(HttpMethod.get)
            .url(this.apiUrls.PAYMENT_METHODS(deliveryPointCode))
            .authorization(this.credentialsStorage.getCredentials())
            .build();
        return this.handler.execute(parameters).pipe(
            map(response => response[FindPaymentMethodsWs.RESULTS_KEY]),
        );
    }

}